import styled from "styled-components";
import { useContext } from "react";
import Context from "../../../Context.js";
import NavBar from "./NavBar.js";
import NavBarMobile from "./NavBarMobile.js";
import ColorThemeSelector from "./ColorThemeSelector.js";
import BrandContainerJustText from "../../brand/BrandContainerJustText.js";

const TopPart = styled.div`
  display: flex;
  flex-direction: column;
  width: 275px;
  margin-top: 0;
  margin-left: 0;
  height: 100vh;
  justify-content: space-between;
  top: 0;
  position: sticky;
  overflow: hidden;
  z-index: 100;
  border-right: 1px solid var(--accentSurface);
  background: var(--headerSurface);
  border-radius: 0;
  padding-top: 30px;
  animation: centerScaleReveal 0.6s ease-in-out forwards;
`;

const Right = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
  padding: 0 10px;
  padding-bottom: 35px;
`;

export default function LoggedInHeader() {
  const { loggedInUser, isMobile, currentRoute } = useContext(Context);

  if (isMobile) {
    return <NavBarMobile />;
  }

  return (
    <TopPart>
      <BrandContainerJustText style={{ color: "var(--headerAccent)" }} />

      <Right>
        <NavBar />
      </Right>
    </TopPart>
  );
}
